// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__rsKT9","close":"modal_close__utpLc","body":"modal_body__ZANP2","head":"modal_head__Q7OR6","form":"modal_form__lChLX","hide":"modal_hide__cwGpP"};